import { Image } from "antd";
import React from "react";

const styles = {
  iframe: {
    border: "none",
    padding: 0,
    margin: 0,
  },
};

const NewsLetterDesign = ({ el }) => {
  if (el?.pdfURLLink?.length > 0) {
    return (
      <div>
        {el.pdfURLLink.map((pdf, index) => (
          <iframe
            key={index}
            src={pdf}
            className={styles.iframe}
            width="100%"
            height="500px"
            style={{ marginBottom: "20px" }}
          />
        ))}
      </div>
    );
  } else if (el?.imageURLs?.length > 0) {
    return (
      <div style={{ textAlign: "center" }}>
        {el.imageURLs.map((url, index) => (
          <Image
            key={index}
            src={url}
            alt={`newsletter image ${index + 1}`}
            height="500px"
            width="90%"
          
          />
        ))}
      </div>
    );
  }
 return null;
};

export { NewsLetterDesign };
